import { Component, Input, OnInit, Pipe } from '@angular/core';
import { IStatistics } from 'app/models/statistics';
import { IUnits } from 'app/models/units';
import { UnitsHelper } from 'app/services/units.helper';
import * as dateHelper from 'app/helpers/date.helpers';
import { IonicModule } from '@ionic/angular';
import { CommonModule, DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-tap-stats',
  templateUrl: './tap-stats.component.html',
  styleUrls: ['./tap-stats.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    DecimalPipe,
  ]
})
export class TapStatsComponent {

  @Input() items: IStatistics[] = [];
  @Input() units!: IUnits;

  dateHelper = dateHelper;

  constructor(public unitsHelper: UnitsHelper) { }

  identify(index: number, item: IStatistics) {
    return item.id;
  }

}
